import { ContentLayout } from '@/bundle/Layouts/ContentLayout/ContentLayout';
import { PageBody } from '@/components/Page/PageBody/PageBody';
import { useState } from 'react';
import { useUser } from '@/context/userContext';
import { Drawer } from '@/components/Drawer/Drawer';
import { Wrapper } from '@/bundle/pages/ProfilePage/styles';
import { UserGeneralDetails } from '../../shared/components/UserDetails/UserGeneralDetails';
import { UserPersonalDetails } from '../../shared/components/UserDetails/UserPersonalDetails';
import { EditPersonalDetailsForm } from '@/bundle/pages/ProfilePage/ui/EditPersonalDetailsForm';
import { Box } from '@/components/Box/Box';
import { ProfileCookiesPreferences } from '@/bundle/shared/components/ProfileCookiesPreferences/ProfileCookiesPreferences';

export const ProfilePage = () => {
  const [openForm, setOpenForm] = useState(false);
  const { user, currentRole, hasOrganizationRole } = useUser();

  const closeForm = () => {
    setOpenForm(false);
  };

  const personalDetails = {
    first_name: user?.first_name,
    middle_name: user?.middle_name,
    last_name: user?.last_name,
  };

  return (
    <ContentLayout title='Profile'>
      <PageBody>
        <Box width='100%' display='flex' flexDirection='column' rowGap='42px'>
          <Wrapper>
            <UserGeneralDetails user={user} currentRole={currentRole} />
            <UserPersonalDetails onEditOpen={() => setOpenForm(true)} personalDetails={personalDetails} isEdit={true} />
          </Wrapper>
          <ProfileCookiesPreferences />
        </Box>
      </PageBody>
      <Drawer
        header='Edit Personal Info'
        subHeader='Please edit your information.'
        isOpen={openForm}
        onClose={closeForm}
      >
        <EditPersonalDetailsForm
          onClose={closeForm}
          isOrgAdmin={hasOrganizationRole}
          personalDetails={personalDetails}
        />
      </Drawer>
    </ContentLayout>
  );
};
